import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	win: 8
};


export const Theme3SubtopicTwoActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema2], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 2 act 3");
			ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act3_a01T3)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, 4].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Ejecución de koxka y salchikoxka" />
					<DialogBarNew
						dialog={`Entraremos en una zona algo distinta a las que ya te he mostrado. También es muy visitada por nuestros Clientes, sobre todo los Jóvenes individualistas, los Estudiantes y los Trabajadores de oficios.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquina Warmer y Koxka y Salchikoxka"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act3_a02T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actThree.actKoxka, "move_koxka")
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Ahora nos encontramos en una zona más fría: el Koxka y el Salchikoxka.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act3_a03T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actThree.actKoxka, "tooltip_koxka")
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Asegúrate de tener a la mano tus tareas para que marques las actividades diarias en esta zona.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actThree.actKoxka)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="¡Veamos a continuación puntos importantes dentro del cuidado del área de koxka y salchikoxka!"
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema2
								})
							);
							navigator("/home3/tema3/subtema2/activityFour");
						}}
					/>
				</>
			)}

		</>
	)
}
